import React from 'react'
import ReactLoadable from 'react-loadable'

export const resolveLoadableComponent = loaded => {
    const hasDefaultExport =
        loaded &&
        typeof loaded === 'object' &&
        Object.prototype.hasOwnProperty.call(loaded, 'default')

    return hasDefaultExport ? loaded.default : loaded
}

export const renderLoadableComponent = (loaded, props) =>
    React.createElement(resolveLoadableComponent(loaded), props)

const Loadable = options =>
    ReactLoadable({
        ...options,
        render: options.render || renderLoadableComponent
    })

Loadable.Map = ReactLoadable.Map
Loadable.Capture = ReactLoadable.Capture
Loadable.preloadAll = ReactLoadable.preloadAll
Loadable.preloadReady = ReactLoadable.preloadReady

export default Loadable
